export default {
    // 通用
    all: '全部',
    search: '查询',
    run: '运行',
    stby: '待机',
    alarm: '报警',
    stop: '停止',
    off: '离线',
    addTime: '添加时间',
    updateTime: '更新时间',
    runStatus: '运行状态',
    runError: '故障',
    temperature: '温度',
    pressure: '压力',
    flow: '流量',
    airVolume: '风量',
    weight: '重量',
    conditions: '查询条件',
    startTime: '开始时间',
    endTime: '结束时间',
    exportData: '导出数据',
    add: '新增',
    delete: '删除',
    ok: '确认',
    cancel: '取消',
    select: '请选择',
    action: '操作',
    edit: '编辑',
    info: '详情',
    addSuccess: '添加成功',
    updateSuccess: '更新成功',
    deleteSuccess: '删除成功',
    delSelectEmpty: '请选择需要删除的项目',
    hotRunnerID: '热流道编号',
    moldNo: '模具编号',
    moldTempMachine: '模温机',
    threeMachine: '三机一体',
    coolWaterMachine: '冷水机',
    cadDryer: '压缩空气干燥机',
    conveyorBelt: '传送带',
    feedSystem: '供料系统',
    robotMachine: '机械手',
    injectionMachine: '注塑机',
    tmc: 'TMC温控箱',
    hediDryer: '保温干燥机',
    refresh: '刷新',
    deleteConfirm: '确认删除',
    // 登录页面
    account: '用户名',
    password: '密码',
    login: '登录',
    companyName: '威海柳道机械有限公司',
    icp: '鲁ICP备18056748号',
    loginEmpty: '帐户名或密码不能为空',
    loginEmpty1: '手机号不能为空',
    loginEmpty2: '手机号格式不正确',
    loginEmpty3: '手机号或验证码不能为空',
    loginEmpty4: '请滑动完成验证',
    loginEmpty5: '手机号、验证码或密码不能为空',
    loginMethod0: '帐户登录',
    loginMethod1: '手机登录',
    register: '注册',
    phoneNumber: '手机号',
    verificationCode: '验证码',
    getVCode: '获取验证码',
    send: '已发送',
    titleName0: '登录TMCC系统',
    titleName1: '注册TMCC系统',
    // header
    rank0: 'VIP',
    rank1: '管理员',
    rank2: '普通用户',
    // main navbar
    menu0: '我的设备',
    menu1: '车间布局',
    menu2: '生产管理',
    menu3: '数据分析',
    menu4: '报警分析',
    menu5: '用户管理',
    menu6: '系统设置',
    // 我的设备
    equipmentSubTitle: '设备管理相关',
    addGroup: '添加机组',
    groupName: '机组名称',
    tagName: '车间名称',
    groupNameEmpty: '机组名称不能为空',
    shopEmpty: '请先选择车间',
    addGroupSuccess: '机组添加成功',
    finishNum: '生产量',
    finishRate: '完成率',
    useRate: '使用率',
    powerNum: '用电量',
    oeeReport: 'OEE报表',
    groupInfo: '机组详情',
    // 机组详情
    back: '返回上一页',
    addDevice: '添加设备',
    delDevice: '删除设备',
    deviceName: '设备名称',
    deviceSerial: '设备序列号',
    deviceType: '设备类型',
    deviceModel: '设备型号',
    deviceRegisteTime: '设备登记时间',
    deviceEmpty: '请至少选择一个设备',
    baseInfo: '基本信息',
    realTimeData: '实时数据',
    watchData: '数据监控',
    realTimeChart: '实时图表',
    powerkwh: '用电量',
    noChart: '无图表',
    // 模温机
    mtsv: '设定温度',
    mtow: '出水温度',
    mtbw: '回水温度',
    mttup: '报警上限',
    mttlow: '报警下限',
    mtrp: '实际压力',
    mtflow: '出水流量',
    // 三机一体
    tmsv: '再生设定温度',
    tmpv: '再生实际温度',
    tmdsv: '干燥设定温度',
    tmdpv: '干燥实际温度',
    tmtup: '报警上限',
    tmtlow: '报警下限',
    tmback: '回风温度',
    tmcwp: '冷却水压力',
    tmcwf: '冷却水流量',
    tmcwt: '冷却水温度',
    tmdp: '露点',
    tmoav: '出风口风量',
    // 冷水机
    cwsv: '设定温度',
    cwow: '出水温度',
    cwam: '报警温度',
    // 压缩空气干燥机
    cadsv: '设定温度',
    cadpv: '实际温度',
    cadtup: '温度上限',
    cadtlow: '温度下限',
    cadpup: '压力上限',
    cadplow: '压力下限',
    cadback: '回风温度',
    caddp: '露点',
    cadcap: '压缩空气压力',
    cadcadp: '压缩空气露点',
    // 传送带
    // 供料系统
    fscw: '当前重量',
    fshw: '累计重量',
    // 机械手
    rtt: '取出时间',
    rct: '周期时间',
    rtn: '取出数量',
    rrpm: '转速',
    rworkmode: '工作模式',
    unknow: '未知',
    manualMode: '手动模式',
    autoMode: '自动模式',
    originMode: '原点复归',
    // 注塑机
    imt1: '第1段炮筒温度',
    imt2: '第2段炮筒温度',
    imt3: '第3段炮筒温度',
    imt4: '第4段炮筒温度',
    imt5: '第5段炮筒温度',
    immc: '成型周期',
    imqty: '产品数量',
    imht1: '第1段保压时间',
    imht2: '第2段保压时间',
    imht3: '第3段保压时间',
    imht4: '第4段保压时间',
    imhp1: '第1段保压压力',
    imhp2: '第2段保压压力',
    imhp3: '第3段保压压力',
    imhp4: '第4段保压压力',
    imct: '冷却时间',
    imit: '注塑时间',
    imis: '注塑速度',
    imip: '注塑最高压力',
    immn: '模数',
    immt: '计量时间',
    imrp: '残量位置',
    barrelTemperature: '炮筒温度',
    holdingPressure: '保压压力',
    injectionPressure: '注塑压力',
    // 温控箱
    tmcps: '注塑压力',
    tmcpt: '注塑温度',
    //测温点状态
    tmcPSts0: '准备',
    tmcPSts1: '停止',
    tmcPSts2: '软启动',
    tmcPSts3: '自动整定',
    tmcPSts4: '自动',
    tmcPSts5: '待机',
    tmcPSts6: '手动',
    tmcPSts11: '温度过高',
    tmcPSts12: '温度过低',
    tmcPSts13: '热电偶开路',
    tmcPSts14: '热电偶反向',
    tmcPSts15: '热电偶短路',
    tmcPSts16: '加热圈开路',
    tmcPSts17: '加热圈短路',
    tmcPSts18: '可控硅击穿',
    tmcPSts19: '保险丝断',
    // 保温干燥机
    hedsv: '设定温度',
    hedpv: '实际温度',
    hedtup: '温度报警上限',
    hedtlow: '温度报警下限',
    // 生产管理
    productionSubTitle: '生产管理相关',
    planID: '计划单号',
    productionNo: '产品编号',
    customerCode: '客户编号',
    customerName: '客户名称',
    productionPlan: '生产计划单',
    addPlan: '添加生产计划单',
    productName: '产品名称',
    planTotal: '计划数量',
    productTotal: '生产数量',
    takeTime: '计划时长',
    planStatus: '任务状态',
    finishPlan: '完成',
    processPlan: '进行中',
    stopPlan: '停止',
    editProductionPlan: '编辑生产计划单',
    startPlan: '开始',
    timeRangeError: '请选择正确的时间范围',
    // 试模文档管理
    testFileSubTitle: '试模文档管理相关',
    testFileID: '文件编号',
    testFileName: '试模文件名',
    testFiles: '试模文档',
    testFileInfo: '试模文档详情',
    testFilePhotos: '试模文档照片列表',
    editTestFile: '编辑试模文档',
    personInCharge: '负责人',
    remark: '备注',
    photo: '照片',
    // 数据分析
    belongFactory: '所属工厂',
    belongTag: '所属车间',
    // 用电量分析
    deviceKindPower: '各设备类型用电量',
    tagPowerList: '各车间用电量',
    groupPowerList: '各机组用电量',
    powerCount: '用电量',
    percent: '百分比',
    // 使用率分析
    allDeviceOEE: '总设备使用率',
    tagOEEList: '各车间设备使用率',
    deviceKindOEEList: '各设备类型使用率',
    groupOEEList: '各机组设备使用率',
    progress: '分布',
    deviceType: '设备类型',
    // 报警管理
    alarmSubTitle: '显示所有报警信息',
    alarmList: '报警信息',
    alarmContent: '报警内容',
    alarmTime: '报警时间',
    // 系统设置
    factoryManageMenu: '工厂管理',
    tagManageMenu: '车间管理',
    deviceManageMenu: '设备管理',
    userManageMenu: '用户管理',
    // 工厂管理
    factoryName: '工厂名称',
    addFactory: '添加工厂',
    deviceCount: '设备数量',
    tagCount: '车间数量',
    groupCount: '机组数量',
    editFactory: '编辑工厂',
    delFactoryTip: '将删除该工厂下属的所有车间,机组,设备,请谨慎选择',
    // 车间管理
    addTag: '添加车间',
    editTag: '编辑车间',
    delTagTip: '将删除该车间下属的所有机组,设备,请谨慎选择',
    // 设备管理
    belongGroup: '所属机组',
    addDeviceMsg1: '请先查询设备信息',
    addDeviceMsg2: '已添加过当前设备,不可重复添加',
    addDeviceMsg3: '当前设备已经被其他用户使用',
    editDevice: '编辑设备',
    delDeviceTip: '将从用户名下删除当前设备,请谨慎选择',
    // 用户管理
    userName: '用户名称',
    userAccount: '用户账户',
    userPassword: '账户密码',
    userRank: '用户等级',
    addUser: '添加用户',
    manageRank: '管理员',
    normalRank: '普通用户',
    changePassword: '修改密码',
    editUser: '编辑用户',
    delUserTip: '该用户账户删除后无法恢复,请谨慎选择!',

    /////////////////////////////////////////*TMMC:a*///////////////////////////////
    //登录界面
    a_noAccount: '没有账号',
    a_registerNow: '立即注册',
    a_protocol1: '注册即表示您同意并愿意遵守柳道',
    a_protocol2: '用户协议及隐私政策',
    a_hadAccount: '已有账号',
    a_loginNow: '直接登录',
    a_smsSended: '短信已发送',
    a_captchaTitle: '请按住滑块，拖动到最右边',
    a_captchaSuccess: '验证通过',
    //二维码界面
    a_waitReview: '等待管理员扫码审核',
    a_qrcodeOver: '二维码失效，点击刷新',
    //我的设备
    a_cardShow: '卡片显示',
    a_listShow: '列表显示',
    a_noShop: '无车间',
    a_hasEmpty: '有未填项',
    //OEE
    a_allDayWorkStatus: '24小时工作状态图',
    a_workClass: '班次',
    a_status: '状态',
    a_statusCount: '次数',
    a_usedTime: '耗时',
    a_DataCount: '数据统计',
    a_pdTarget: '生产目标',
    a_finishNm: '完成量',
    a_rejectNm: '不良品',
    a_noStart: '未开始',
    //车间布局
    a_noLayoutImg: '无布局图',
    a_aboutLayout: '工厂布局相关',
    a_LayoutPic: '布局图',
    //生产管理
    a_costAnalysis: '成本分析',
    a_staff: '工作人员',
    a_deleteProductionPlan: '删除生产计划单',
    a_deleteProductionWaring: '删除生产计划单将同时删除生产计划单下所有信息，确认删除？',
    //数据分析
    a_powerAnalysisMenu: '用电量分析',
    a_oeeAnalysisMenu: '使用率分析',
    a_productAnalysisMenu: '生产量分析',
    a_allPower: '总用电量',
    a_january: '一月',
    a_february: '二月',
    a_march: '三月',
    a_april: '四月',
    a_may: '五月',
    a_june: '六月',
    a_july: '七月',
    a_august: '八月',
    a_september: '九月',
    a_october: '十月',
    a_november: '十一月',
    a_december: '十二月',
    a_standend: '标准',
    a_averageValue: '平均值',
    a_allProductNm: '总生产量',
    a_averageOee: '平均使用率',
    //用户管理
    a_userManageAbout: '用户管理相关',
    a_registerTime: '注册时间',
    a_deleteUser: '删除用户',
    a_deleteFail: '删除失败',
    a_sureDeleteUser: '确定删除用户',
    // 系统设置
    a_workTimeSet: '排班设定',
    //车间管理
    a_deleteTag: '删除车间',
    a_tagSort: '车间排序',
    a_deleteTagWaring: '删除车间将同时删除车间下所有信息，确认删除？',
    //排班设定
    a_addClass: '添加排班',
    a_saveClass: '保存排班',
    a_className: '排班名称',
    a_workingHours: '上班时间',
    a_afterWorkingHours: '下班时间',
    a_editClass: '编辑排班',
    a_workingTime: '工作时间',
    a_deleteClass: '删除排班',
    a_sureDeleteClass: '确定删除排班',
    //车间布局
    a_draw: '绘图',
    a_toBeProcessed: '待处理',
    a_deviceAllNum: '设备总数量',
    a_pendingNum: '待处理数量',
    a_description: '说明',
    a_description1: '设置车间宽高(宽*高)',
    a_description2: '上传车间背景图片',
    a_description3: '将待处理区的设备拖入到绘图区域的车间框中',
    a_description4: '双击矩形块(单个或多个)编辑位置和尺寸(X*Y,宽*高)',
    a_description5: '双击矩形块,删除设备',
    a_description6: '清除车间布局',
    a_description7: '设计完成保存车间布局',
    a_upload: '上传',
    a_reset: '重置',
    a_save: '保存',
    a_saveSuccess: '保存成功',
    a_savefail: '保存失败',
    //设备管理
    a_unassignedWorkshop: '未分配车间',
    a_NonAssignmentWorkshop: '不分配车间',
    a_deviceSort: '设备排序',
    a_sureDelDevice: '确定删除设备',

    /////////////////////////////////////////*TMCC:b*///////////////////////////////
    //设备种类
    b_MoldTemp: '模温机(KH54401A)',
    b_ThreeMachineDF: '三机一体(DF879500A)',
    b_CoolingWater: '冷水机(SF306000A)',
    b_Cadryer: '压缩空气干燥机(D-100)',
    b_ConveyorBelt: '传送带',
    b_AutoFeedingController: '自动供料控制器',
    b_Robot1100: '机械手(TRC-1100)',
    b_InjectionJSU: '注塑机(JSU)',
    b_TMC: 'TMC温控箱',
    b_Dryer: '干燥机(HC-100)',
    b_InjectionKLS: '注塑机(KLS)',
    b_Robot990: '机械手(TRC-990)',
    b_ThreeMachineSF: '三机一体(SF879500A)',
    b_Mold: '模具(MOLD-01A)',
    b_AutoDetection: '瓶盖检测自动化(F181219R-00-00A)',
    //首页
    b_groupSort: '机组排序',
    b_selectDevice: '选择设备',
    b_operator: '操作员',
    b_noZhuSuJi: '机组无注塑机',
    //机组
    b_seeTMCDetail: "查看温控箱详情",
    b_exitTMCDetail: "退出温控箱详情",
    b_noDevice: "该机组内无设备",
    b_removeDevice: "移除设备",
    b_timeRangeSearch: "按时间段查询",
    b_realTime: "实时",
    b_hour: "小时",
    b_day: "天",
    b_makeSure: "确定",
    b_setShowProperies: "设定显示属性",
    b_timeRangeEmpty: "时间范围不能为空",
    b_endBeforeStart: "结束时间不能早于开始时间",
    b_only30Days: "只能查询近30天的数据",
    b_rangeMore1Day: "查询的范围不能大于1天",
    b_mainDevice: '主设备',
    //报警
    b_serialTBOX: "TBOX序列号",
    //机组管理
    b_groupM: "机组管理",
    //设备管理
    b_unassignedGroup: '未分配机组',
    b_NonAssignmentGroup: '不分配机组',
};



// WEBPACK FOOTER //
// ./src/locale/zh_cn.js